import { render } from "./EventDetailView.vue?vue&type=template&id=60885fd2&ts=true"
import script from "./EventDetailView.vue?vue&type=script&lang=ts"
export * from "./EventDetailView.vue?vue&type=script&lang=ts"

import "./EventDetailView.vue?vue&type=style&index=0&id=60885fd2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__